module.exports = __webpack_public_path__ + "static/media/Spoonerism-C-instructions.83394083.mp3";